import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../me'
import * as contexts from '../contexts'
import * as editingVariables from '../editing-variables'
import * as portalAccess from '../portal-access'

import { Api } from './api.service'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Provides a collection of apps within the zone in Admin portal
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link editingVariables.Feature} */
  private readonly _editingVariablesFeature = ngCore.inject(
    editingVariables.Feature,
  )
  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)
  constructor() {
    const _contexts = ngCore.inject(contexts.Feature)
    const _meFeature = ngCore.inject(me.Feature)
    super({
      api: ngCore.inject(Api),
      context$: _contexts.selectors.zoneContext.asObservable,
      identify: app => app.id,
      name: ec.Name.Predefined.AdminApp,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: app }) => ({
              iconsConfigs: portalAccess.ContentActionAccess.canDeleteChild({
                context: _contexts.selectors.zoneContext.asSignal(),
                entity: app,
                user: _meFeature.selectors.currentUser.asSignal(),
              })
                ? [
                    {
                      class: 'atn-icon atn-trash atn-red',
                      onClick: () => {
                        collection.plugins.editingPlugin.feature.actions.markForDeletion
                          .from(`Table.Row-${app.alias}.Buttons.Trash.Clicked`)
                          .dispatch({ id: app.id })
                      },
                    },
                  ]
                : [],
              onClick: () => {
                const source = `Table.Row-${app.alias}.Clicked`

                const url = _contexts.selectors.getUrlForApp(app).asSignal()
                // Navigate to app editing page
                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          })),
        ],
        currentList: {
          sortBy: { get: key => key ?? 'name' },
        },
      },
    })
    this.feature.registerEffects(
      effects.syncCurrentEntityWithUrl(this, this._router),
      effects.syncAppVariablesForEditing(this, this._editingVariablesFeature),
    )
  }
}
